export default {
    // 分页获取Gardener用户列表
    gardenerAPList: "/maintenance/pay/gardener/getGardenerVendorPage",
    // 根据vendorId分页获取maitance数据
    gardenerAPMaitanceList: "/maintenance/pay/gardener/showByVendor",
    // 根据maintance_id修改glacct 和 do not pay
    updateGlAcctAndStatusToInfo: "/maintenance/pay/gardener/updateGlAcctAndStatusToInfo",
     // 修改gardener 推账单
    gardenerSendToVendorPayment: "/maintenance/pay/gardener/sendToVendorPayment",
    // 获取GL_Account数据
    gardenerGLAccountList:"/maintenance/pay/gardener/getGlAcctList",
};